import Box from '@mui/joy/Box'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
    useRouteError,
    isRouteErrorResponse,
} from 'react-router-dom'

export default function ErrorView({
    embedded,
}: {
    embedded?: boolean,
}) {

    const { t } = useTranslation()

    const error = useRouteError()
    console.error(error)

    return (
        <Box p={2}>
            <h1>{t('error.heading')}</h1>
            {embedded ?
                <>
                    <h4>{t('error.titleEmbedded')}</h4>
                    <p>{t('error.textEmbedded')}</p>
                </>
                :
                <h4>{t('error.title')}</h4>
            }
            <p>{t('error.moreInfo')}</p>
            {isRouteErrorResponse(error) ?
                <p>
                    {error.status &&
                        <i>{error.status} - </i>
                    }
                    <i>{error.statusText || error.data.message}</i>
                </p>
                :
                <Box sx={{
                    whiteSpace: 'pre-wrap',
                    maxWidth: '100%',
                    overflowX: 'auto',
                    fontSize: '14px',
                }}>
                    {/* biome-ignore lint/suspicious/noExplicitAny: error is always of type unknown */}
                    {(error as any)?.stack &&
                        <i>
                            {/* biome-ignore lint/suspicious/noExplicitAny: error is always of type unknown */}
                            {(error as any).stack}
                        </i>
                    }
                </Box>
            }
        </Box>
    )
}
